module.exports = {
      id: "olympic-usage",
      viewBox: "0 0 11.388 19.966",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#olympic",
      toString: function () {
        return this.url;
      }
    }